module.exports = __webpack_public_path__ + "img/New_footer_asu_logo.aa85042b.png";